<template lang="pug">
  .container.grid-lg
    page-title(title="Meu curso" icon="fas fa-graduation-cap" subtitle="Detalhes do curso")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    .columns(v-else-if="course")
      .column.col-6.col-md-12.mb-2.pb-2
        .panel.height-100
          .panel-header
            .panel-title.text-bold {{ course.title }}
          .panel-nav
            ul.tab.tab-block
              li.tab-item
                router-link(:to="{ name: 'content.courses.show' }")
                  i.fas.fa-fw.fa-search
                  | &nbsp;Detalhes
              li.tab-item
                router-link(:to="{ name: 'content.courses.show.authors' }")
                  i.fas.fa-fw.fa-users
                  | &nbsp;Autores
              li.tab-item
                router-link(:to="{ name: 'content.courses.show.plans' }")
                  i.fas.fa-fw.fa-list-ul
                  | &nbsp;Planos
          router-view(:course="course" :plans="plans")
          .panel-footer
            .divider
            .tile(v-if="course.availableLanguages.length > 0")
              .tile-content
                .tile-title Idiomas do curso
                .tile-subtitle
                  .columns.col-gapless(v-for="language in course.availableLanguages")
                    .column.col-auto
                      img.brand(:src="languageInfo(language).brand")
                    .column
                      small.pl-1 {{ languageInfo(language).label }}
      .column.col-6.col-md-12.mb-2.pb-2
        .panel.height-100
          .panel-header
            .panel-title.text-bold Capítulos do curso
          .panel-body
            item-row(v-for="item in course.productItems" :key="item.id" :item="item" :watched-time="watchedTime")
          .panel-footer
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import api from '@/services/api/courses'
import { LANGUAGES } from '@/config/constants'
import ItemRow from './components/ItemRow'

export default {
  data() {
    return {
      course: null,
      watchedTime: [],
      plans: [],
      loading: false,
      error: null,
    }
  },
  components: { ItemRow },
  watch: {
    '$route.params.id'() {
      this.fetchData()
    },
  },
  methods: {
    async fetchData(id) {
      try {
        this.loading = true
        this.error = null
        const showPromise = api.show(this.$route.params.id)
        const watchedTimePromise = api.watchedTime(this.$route.params.id)
        const plansPromise = api.plansOfCourse(this.$route.params.id)
        const [courseRes, watchedTimeRes, plansRes] = await Promise.all([
          showPromise,
          watchedTimePromise,
          plansPromise,
        ])
        this.course = courseRes.data
        this.watchedTime = watchedTimeRes.data
        this.plans = plansRes.data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    languageInfo(language) {
      return LANGUAGES[language]
    },
  },
  created() {
    this.fetchData()
  },
}
</script>

<style lang="stylus" scoped>
.brand
  width 25px
</style>
